import firebase from './firebase'

export const Message = ({ author, body, createdAt = +new Date }) => ({
  author,
  body,
  createdAt
})

export const getMessagesCollection = () =>
  firebase.firestore().collection('messages')

export const addMessage = ({ author, body, createdAt }) =>
  getMessagesCollection().add({ author, body, createdAt })

export const mapDocuments = ref => {
  return ref.docs.map(doc => ({
    ...doc.data(),
    _id: doc.id
  }))
}
